import React from 'react'
import { useAppDispatch } from 'reduxTyped'

import * as uiActions from 'common/core/actions/uiActions'
import SettingsModalButton from 'common/settings/components/SettingsModalButton'
import { SettingsTabType } from 'common/settings/constants/SettingsTabType'

const CompactSettings = ({
  className,
  children,
  defaultTab = SettingsTabType.GENERAL,
}: {
  className?: string
  children?: JSX.Element
  defaultTab: SettingsTabType
}) => {
  const dispatch = useAppDispatch()

  const handleClick = () => {
    dispatch(uiActions.openCompactSettingsModal(defaultTab))
  }

  return (
    <span>
      {children ? (
        React.cloneElement(children, {
          onClick: handleClick,
        })
      ) : (
        <SettingsModalButton onClick={handleClick} className={className} />
      )}
    </span>
  )
}

export default CompactSettings
